import React from "react";
import * as XLSX from "xlsx";
import {useDataProvider, useListContext, Button} from 'react-admin';
import DownloadIcon from '@mui/icons-material/Download';

const ExportExcelButton = ({total, fileName, sheetName}) => {
    const {filterValues} = useListContext();
    const dataProvider = useDataProvider();

    let w_fileName, w_sheetName;
    fileName ? w_fileName = fileName + ".xlsx" : w_fileName = 'Proveedores.xlsx';
    sheetName ? w_sheetName = sheetName : w_sheetName = 'Hoja 1';

    const handleClick = () => {
        // Data para exportar
        dataProvider.getList(
            'proveedor',
            {
                filter: {
                    persona_tipo_d: filterValues.persona_tipo_d,
                    persona_forma_d: filterValues.persona_forma_d,
                    documento_nro: filterValues.documento_nro,
                    cuit_cuil: filterValues.cuit_cuil,
                    d_iva: filterValues.d_iva,
                    es_pyme: filterValues.es_pyme,
                    estado_proveedor_abre: filterValues.estado_proveedor_abre,
                    fecha_alta_desde: filterValues.fecha_alta_desde,
                    fecha_alta_hasta: filterValues.fecha_alta_hasta,
                    pro: filterValues.pro,
                    pais: filterValues.pais,
                    proveedor: filterValues.proveedor,
                    provincia: filterValues.provincia,
                    razon_social: filterValues.razon_social,
                    ciudad: filterValues.ciudad,
                    q: filterValues.q
                },
                sort: {field: 'id', order: 'ASC'},
                pagination: {page: 1, perPage: total},
            },)
            .then(({data}) => {
                downloadExcel(data);
            })
            .catch(error => {
                console.log(error)
            });
    };

    // JN Creo un nuevo JSON sólo con los campos que quiero mostrar en el excel
    // Ajusta el ancho de las columnas automaticamente segun el contenido
    const fitToColumn = data_export => {
        const columnWidths = [];
        for (const property in data_export[0]) {
            columnWidths.push({wch: Math.max(property ? property.toString().length : 0, ...data_export.map(obj => obj[property] ? obj[property].toString().length : 0))});
        }
        return columnWidths;
    };

    const downloadExcel = (data) => {
        let data_export = data.map(({
                                        pro,
                                        razon_social_xls,
                                        documento_tipo_d_xls,
                                        cuit_cuil,
                                        persona_tipo_d_xls,
                                        persona_forma_d,
                                        estado_proveedor_abre,
                                        d_pais_comercial,
                                        provincia_comercial_d,
                                        comercial_partido,
                                        ciudad_comercial_d,
                                        comercial_calle,
                                        comercial_calle_nro,
                                        comercial_piso,
                                        comercial_departamento,
                                        comercial_codigo_postal,
                                        correo_electronico,
                                        telefono_area,
                                        telefono_nro,
                                        codigo_pro_tvpublica,
                                        codigo_pro_rna
                                    }) => ({
            pro,
            razon_social_xls,
            documento_tipo_d_xls,
            cuit_cuil,
            persona_tipo_d_xls,
            persona_forma_d,
            estado_proveedor_abre,
            d_pais_comercial,
            provincia_comercial_d,
            comercial_partido,
            ciudad_comercial_d,
            comercial_calle,
            comercial_calle_nro,
            comercial_piso,
            comercial_departamento,
            comercial_codigo_postal,
            correo_electronico,
            telefono_area,
            telefono_nro,
            codigo_pro_tvpublica,
            codigo_pro_rna
        }));

        const worksheet = XLSX.utils.json_to_sheet(data_export);
        worksheet['!cols'] = fitToColumn(data_export);

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, w_sheetName);
        XLSX.utils.sheet_add_aoa(worksheet, [["Pro", "Razón Social", "Documento Tipo", "Cuit-Cuil", "Persona Tipo", "Persona Forma", "Estado Proveedor", "Pais", "Provincia", "Partido", "Ciudad", "Calle", "Nro Calle", "Piso", "Departamento", "Cód. Postal", "Email", "Tel.Cod.Area", "Tel.Número", "Cód. TV Pública", "Cód. RNA"]], {origin: "A1"});

        XLSX.writeFile(workbook, w_fileName);
    };
    return (
        <Button
            onClick={() => handleClick()}
            label="excel"
        >
            <DownloadIcon/>
        </Button>
    )
};

export default ExportExcelButton;
